export default __webpack_public_path__ + "static/media/rightDarkAnchor.77d5931c.svg";